import React from "react";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";

import { Breadcrumb } from "antd";
const IBreadcrumb = ({ items }) => {
  return (
    <div className="mb-3">
      <Breadcrumb items={items} />
    </div>
  );
};

export default IBreadcrumb;
